























import { PartialResult } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export default class DefaultPartialResult extends Vue {
  @Prop({ required: true })
  private partialResult: PartialResult;

  @Prop({ default: 4 })
  private columns: number;

  get title() {
    const message = this.$x.messages.partialResult.titleHTML;
    return this.$options.filters.compileMessage(message, {
      term: this.partialResult.term,
      numFound: this.partialResult.numFound
    });
  }

  emitViewPartialResult() {
    this.$x.emit(EVENTS.ViewPartialResult, this.partialResult);
  }
}
